module.exports = __webpack_public_path__ + "img/logo_text.df4b75f2.png";